import * as Sentry from "@sentry/react";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (!sentryDsn) {
	console.error(
		"[sentry] VITE_SENTRY_DSN is not set — errors will not be sent",
	);
} else {
	Sentry.init({
		dsn: sentryDsn,
		initialScope: { tags: { app: "futchampion" } },
		environment: import.meta.env.MODE,
		release: import.meta.env.VITE_SENTRY_APP_RELEASE,
		integrations: [Sentry.browserTracingIntegration()],
		tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1,
	});
}
